module.exports = __webpack_public_path__ + "media/customizations/wildblue/logo-06238e72af0be9c7d23524df8d973d44.png";